import { useState, useEffect } from 'react';
import { IPermissoes, IPerfil } from "../../interfaces/IPermissoes";
import { Modal } from 'react-bootstrap-v5';

const PermissoesModal = ({ toggleModal, salvar, show, permissao, perfis, title }: { toggleModal: () => void, salvar: (permissao: IPermissoes) => void, show: boolean, permissao: IPermissoes | undefined, perfis: IPerfil[], title: string }) => {
  
  const [carregado, setCarregado] = useState<boolean>(false);
  const [permissaoTemporaria, setPermissaoTemporaria]= useState<IPermissoes>({} as IPermissoes);

  useEffect(() => {

    function preCarregar() {
      setCarregado(false);
      const perm = permissao ?? {perfilID: perfis[0].id || 1} as IPermissoes;
  
      setPermissaoTemporaria(perm);
      setCarregado(true);
    }

    preCarregar()
    
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, permissao]);
  
  return <Modal maxwidth= '600px' centered={true} show={show} onHide={toggleModal}>
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title titulo-modal">{title}</h5>
        <div className="btn btn-icon btn-sm btn-active-light-primary ms-2">
          <i onClick={toggleModal} className="fas fa-times" style={{ color: '#5E6397' }}></i>
        </div>
      </div>
      <div className="modal-body">
      {
        carregado ? 
        <form className="row g-3">
          <div className="col-md-12">
            <label htmlFor="form-descricao" className="form-label required" >Descrição</label>
            <input placeholder="Digite Algo" type="text" className="form-control" id="form-descricao" defaultValue={permissaoTemporaria.descricao} onChange={e => setPermissaoTemporaria({...permissaoTemporaria, descricao: e.target.value})}/>
          </div>
          <div className="col-md-12">
            <label htmlFor="form-chave" className="form-label required">Chave</label>
            <input placeholder="Digite referente a função" type="text" className="form-control" id="form-chave" defaultValue={permissaoTemporaria.chave} onChange={e => setPermissaoTemporaria({...permissaoTemporaria, chave: e.target.value})}/>
          </div>
          <div className="col-md-12">
            <label htmlFor="form-perfil" className="form-label required">Perfil</label>
            <select placeholder="Selecione um perfil" className="form-select" id="form-perfil" value={permissaoTemporaria.id} onChange={e => {
              setPermissaoTemporaria({...permissaoTemporaria, perfilID: perfis.find(x => `${x.id}` === e.target.value)?.id})
            }}>
              {
                perfis.map((x, index) => <option key={index} value={x.id} className="form-label">{x.nome}</option>)
              }
            </select>
          </div>
          <div className="col-md-12">
            <label htmlFor="form-cpf" className="form-label required">Permissões</label>
            <div style={{border: '1px solid #DFDFDF', borderRadius:'5px'}}>
              <div style={{borderBottom:'1px solid #DFDFDF',padding: '5px', display:'flex'}}>
                <label className="form-check-label" style={{paddingLeft:'5px'}} >Vizualizar</label>
                <div className="form-check form-switch" style={{marginLeft:'335px',float:'right'}} >
                  <input className="form-check-input" type="checkbox" defaultChecked={permissaoTemporaria.visualizar} onChange={e => setPermissaoTemporaria({...permissaoTemporaria, visualizar: e.target.checked})}/>
                </div>
              </div>
              <div style={{borderBottom:'1px solid #DFDFDF',padding: '5px', display:'flex'}}>
                <label className="form-check-label" style={{paddingLeft:'5px'}} >Criar ou Editar</label>
                <div className="form-check form-switch" style={{marginLeft:'310px',float:'right'}} >
                  <input className="form-check-input" type="checkbox" defaultChecked={permissaoTemporaria.criarEditar} onChange={e => setPermissaoTemporaria({...permissaoTemporaria, criarEditar: e.target.checked})}/>
                </div>
              </div>
              <div style={{borderBottom:'1px solid #DFDFDF',padding: '5px', display:'flex'}}>
                <label className="form-check-label" style={{paddingLeft:'5px'}} >Importar arquivos</label>
                <div className="form-check form-switch" style={{marginLeft:'290px',float:'right'}} >
                  <input className="form-check-input" type="checkbox" defaultChecked={permissaoTemporaria.importarArquivo} onChange={e => setPermissaoTemporaria({...permissaoTemporaria, importarArquivo: e.target.checked})}/>
                </div>
              </div>
              <div style={{padding: '5px', display:'flex'}}>
                <label className="form-check-label" style={{paddingLeft:'5px'}} >Excluir</label>
                <div className="form-check form-switch" style={{marginLeft:'352px',float:'right'}} >
                  <input className="form-check-input" type="checkbox" defaultChecked={permissaoTemporaria.excluir} onChange={e => setPermissaoTemporaria({...permissaoTemporaria, excluir: e.target.checked})}/>
                </div>
              </div>
            </div>
          </div>
        </form> 
        :
        <p>Carregando...</p>
      }
      </div>
      <div className="modal-footer" style={{ margin: '0 auto' }}>
        <button onClick={toggleModal} type="button" className="btn btn-modal-cancelar me-5"> CANCELAR </button>
        <button onClick={() => {
            salvar(permissaoTemporaria);
        }} type="button" className="btn btn-primario ms-5"> {permissaoTemporaria.id ? 'EDITAR' : 'CADASTRAR'} </button>
      </div>
    </div>
  </Modal>
}

export default PermissoesModal;